import React, { useEffect, useState } from "react";

// Icon Imports
import {
  MdAddToQueue,
  MdOutlineReport,
} from "react-icons/md";
import AddHours from "./components/AddHours";
import Invoice from "./components/Invoice";

interface TabProps {
  icon?: React.ReactNode;
  label: string;
  content: React.ReactNode;
}

interface TabContentProps {
  tabId: string;
}


const tabsData: TabProps[] = [
  { icon:<MdAddToQueue className="h-6 w-6"/>, label: 'Add Hours', content: <p>
    <span className="font-semibold text-2xl flex justify-center text-indigo-600 font-[font-serif] text-shadow-lg/20">Daily Timecard</span></p> },
  { icon:<MdOutlineReport className="h-6 w-6"/>, label: 'Invoice', content: <p><span className="font-semibold text-2xl flex justify-center text-indigo-600 font-[font-serif]">View Invoice</span></p> },
];

const TabContent: React.FC<TabContentProps> = ({ tabId }) => {



  useEffect(() => {
    setTimeout(() => {
      // setData(`Updated content for ${tabId}`);
    }, 300);
  }, [tabId]); // Re-run effect when tabId changes

  return (
    <div>
      {tabId === 'add-hours' && (
        <AddHours />
      )}
      {tabId === 'invoice' && (
        <Invoice />
      )}
    </div>
  );
};

const HoursAndInvoice = () => {
  const [activeTab, setActiveTab] = useState(0);
 
    const handleTabClick = (tabIndex: number) => {
      setActiveTab(tabIndex);
   };
  return (
    <div className="col-span-4 lg:!mb-0 mt-4 block rounded-lg rounded-full bg-gradient-to-b from-white/50 to-white/10" >
   
  
      {/* Tab Headers */}
      <div className="flex rounded rounded-lg bg-gradient-to-r from-white to-indigo-200 p-2">
        {tabsData.map((tab, index) => (
          <button
            key={index}
            className={`
              flex items-center space-x-2 px-4 py-3 text-sm font-medium transition-colors duration-200 rounded-t-lg 
              ${activeTab === index
                ? 'text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-400 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 '
                : 'text-gray-800 hover:text-blue-600 hover:border-b-2 hover:border-blue-500'
              }
            `}
            onClick={() => { handleTabClick(index) }}
          >
            {tab.icon}
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      
      <div className="mt-4 p-4 bg-white rounded shadow rounded-[10px] shadow-md ">
        {tabsData[activeTab].content} 
         {tabsData[activeTab].label === 'Add Hours' && (
          <TabContent tabId="add-hours" />
        )}
        {tabsData[activeTab].label === 'Invoice' && (
          <TabContent tabId="invoice" />
        )}
      </div>
    </div>
  );
};

export default HoursAndInvoice;
